module.exports = __webpack_public_path__ + "static/prepare-03e1aaee44ac6ed7bd1e73f3bf830e49.jpg";